import { useEffect } from "react";
import { _AdquisitionItem, _AdquisitionPlan } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../theme/Component/PrintJson";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../theme/Component/BasicTable";
import useModal, { MODAL_LG, MODAL_md } from "../../theme/Component/hooks/useModal";
import { Modal } from "../../theme/Component/Modal";
import { AdquisitionItem } from "../adquisition-setting/AdquisitionItem";
import { AdquisitionItemCatalog } from "../AdquisitionItemCatalog";
import { AdquisitionItemForm } from "../AdquisitionItemForm";

interface Props{
    type:number;
    idBean:number;
}
export const PlanEvents =({type,idBean}:Props)=>{

    const _item = useDataBean(_AdquisitionPlan);
    const {lista,setLista,bean,setBean,instance} = _item;
    const modalItem = useModal("Detalle",MODAL_LG);

    useEffect(()=>{
        getEvents();
    },[idBean,type])
    useEffect(()=>{
        if(bean.IDPlanEvent)
            defaultAction();
    },[bean])

    const getEvents=()=>{
        instance.getPlanEventRender(1,15,{TypeEvent:type,IDBean:idBean}).then(
            (resp:any)=>{
                if(Array.isArray(resp.List)){
                            resp.List.forEach(element => {
                                try {
                                    if (element.DataBeanProperties && element.DataBeanProperties.JSONData) {
                                        element.DataBeanProperties = {
                                            ...JSON.parse(element.DataBeanProperties.JSONData),
                                            ...element.DataBeanProperties
                                        };
                                    }
                                } catch (error) {
                                    console.error("Error parseando JSONData para el elemento:", element, error);
                                }
                            });

                    setLista(resp.List);      
                }          
            }
        )
    }

    const getHead=()=>{
        switch (type) {
            case 2:  //item
            return headAdquisitionItem;                        
            default:
                return headDefault;
                
        }
        
    }
    const defaultAction=()=>{
        modalItem.open();
    }
        
     const headDefault = [
            { title: '#', property: "IDPlanEvent", mask: MASK_NUMBER },
            { title: 'Fecha', property: 'Since' },
        ];
        const headAdquisitionItem = [
            { title: '#', property: "IDPlanEvent",visible:false, mask: MASK_NUMBER },
            { title: 'Modificado', property: 'Since' },
            { title: 'Valor Total Estimado', property: 'TotalValue',mask:MASK_MONEY },
            { title: 'Necesidad', property: 'Description' },
            { title: 'Funcionario', property: 'EmployeeFullName' },
     ];

    return(
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={getHead()} rowSet={setBean}></BasicTable>
                <Modal modal={modalItem.modal} updateModal={modalItem.setModal}>
                    <>
                    {type === 2 &&
                        <AdquisitionItemForm
                            beanItem={bean}
                            setBeanItem={setBean}
                            rol={1}
                            
                        />
                    }
                    </>
                </Modal>
                {/* <PrintJson json={lista}/> */}
            </div>
        </div>
    )
}